<template>
  <div class="">
    <label v-show="label" class="label">
      <span v-if="required" class="col-red">*</span>
      {{ label }}
    </label>
    <el-date-picker
      v-model="val"
      :type="type"
      :placeholder="placeholder"
      :range-separator="rangeSeparator"
      :format="format"
      :value-format="format"
      :picker-options="pickerOptions"
      @change="changeHandle">
    </el-date-picker>
  </div>
</template>
<script>
import {
  DatePicker
} from 'element-ui'
export default {
  name:'dateBox',
  props:{
    label:{
      type:String,
      default:''
    },
    required:{
      type: Boolean,
      default: false
    },
    value:{

    },
    type:{
      type:String,
      default:'datetime'
    },
    placeholder:{
      type:String
    },
    rangeSeparator:{
      type:String,
      default:'-'
    },
    format:{
      type:String,
      default(){
        return 'yyyy.MM.dd HH:mm:ss'
      }
    },
    pickerOptions:{
      type: Object,
      default:{}
    }
  },
  data(){
    return {

    }
  },
  methods:{
    changeHandle(v){
      this.$emit('change',v)
    }
  },
  mounted(){

  },
  computed:{
    val:{
      get(){
        return this.value;
      },
      set(v){
        this.$emit('input',v);
      }
    },
  },
  components:{
    elDatePicker:DatePicker
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/dateBox.vue